import React from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { FeedScope } from '../../api/models/Feed';

interface CreateFeedDialogProps {
  open: boolean;
  feedName: string;
  feedScope: FeedScope;
  createError: string | null;
  isLoading: boolean;
  isValidating: boolean;
  feedNameExists: boolean;
  onClose: () => void;
  onFeedNameChange: (name: string) => void;
  onFeedScopeChange: (scope: FeedScope) => void;
  onCreateFeed: () => Promise<void>;
}

const getValidationHelperText = (isValidating: boolean, feedNameExists: boolean): string => {
  if (isValidating) return 'Validating...';
  if (feedNameExists) return 'A feed with this name already exists';
  return '';
};

const CreateFeedDialog: React.FC<CreateFeedDialogProps> = ({
  open,
  feedName,
  feedScope,
  createError,
  isLoading,
  isValidating,
  feedNameExists,
  onClose,
  onFeedNameChange,
  onFeedScopeChange,
  onCreateFeed,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create New Azure Feed</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Feed Name"
          fullWidth
          variant="outlined"
          value={feedName}
          onChange={(e) => onFeedNameChange(e.target.value)}
          error={!!createError || feedNameExists}
          helperText={
            createError || getValidationHelperText(isValidating, feedNameExists)
          }
          sx={{ mt: 2 }}
        />
        <FormControl sx={{ mt: 3 }}>
          <FormLabel>Scope</FormLabel>
          <RadioGroup
            row
            value={feedScope}
            onChange={(e) => onFeedScopeChange(e.target.value as FeedScope)}
          >
            <FormControlLabel
              value={FeedScope.Organisation}
              control={<Radio />}
              label={FeedScope.Organisation}
            />
            <FormControlLabel
              value={FeedScope.Project}
              control={<Radio />}
              label={FeedScope.Project}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onCreateFeed}
          variant="contained"
          disabled={isLoading || isValidating || !feedName.trim() || feedNameExists}
        >
          {isLoading ? 'Creating...' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateFeedDialog;
